import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'
import { composeStyle } from '@xhs/yam-beer/core/system/compose'

export default function initStye() {
  return [
    registerThemeSpec('cmp.icon', composeStyle.var('size', {
      width: '_VAR_px',
      height: '_VAR_px',
      fill: composeStyle.when('color')
        .truthy(composeStyle.var('color', '_VAR_')),
    })),
    registerThemeSpec('cmp.custom-icon', {
      cursor: 'pointer',
      '&:hover': {
        '.line': {
          stroke: 'brand',
        },
        '.area': {
          fill: 'brand',
        },
      },
      '.line': {
        stroke: '#888',
      },
      '.area': {
        fill: '#888',
      },
    }),
  ]
}
